"use client";

import * as React from "react";
import { useFormStatus } from "react-dom";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

function SubmitButton() {
  const { pending } = useFormStatus();

  return (
    <Button type="submit" className="w-full" disabled={pending} aria-busy={pending} aria-live="polite">
      {pending ? "Signing in..." : "Sign in"}
    </Button>
  );
}

export interface AuthFormProps {
  loginAction: (formData: FormData) => Promise<never>;
  defaultEmail?: string;
  redirectTo?: string;
}

export function AuthForm({ loginAction, defaultEmail, redirectTo }: AuthFormProps) {
  const [rememberMe, setRememberMe] = React.useState(true); // Default to true for better UX
  
  return (
    <form action={loginAction} className="grid gap-4">
      {redirectTo ? <input type="hidden" name="redirectTo" value={redirectTo} /> : null}
      <input type="hidden" name="rememberMe" value={rememberMe ? "true" : "false"} />
      
      <div className="grid gap-2">
        <Label htmlFor="email">Email</Label>
        <Input id="email" name="email" type="email" autoComplete="email" required defaultValue={defaultEmail} />
      </div>
      <div className="grid gap-2">
        <Label htmlFor="password">Password</Label>
        <Input
          id="password"
          name="password"
          type="password"
          autoComplete="current-password"
          minLength={6}
          required
        />
      </div>
      
      <div className="flex items-center space-x-2">
        <Checkbox
          id="remember"
          checked={rememberMe}
          onCheckedChange={(checked) => setRememberMe(checked === true)}
        />
        <Label
          htmlFor="remember"
          className="text-sm font-normal cursor-pointer"
        >
          Keep me logged in for 30 days
        </Label>
      </div>
      
      <SubmitButton />
    </form>
  );
}
